// extracted by mini-css-extract-plugin
export default {"gray500":"#adb5bd","Slide":"GalleryItem_Slide__XSCoD"};